import { apiClient } from '@/core/api/client';
import { Endpoints } from '@/core/api/endpoints';
import type { UnitInstallmentsResponse } from '@/core/api/models/unitInstallments';

class UnitInstallmentsService {
    /**
     * Fetch unit installments for a specific unit
     * @param unitId - The unit ID (salesorder_id)
     * @returns UnitInstallmentsResponse with overdue, upcomingDue, future, and paid installments
     */
    async getUnitInstallments(unitId: string): Promise<UnitInstallmentsResponse> {
        return await apiClient.get<UnitInstallmentsResponse>(
            Endpoints.profile.unitInstallments,
            {
                params: {
                    unitId,
                },
            }
        );
    }
}

export const unitInstallmentsService = new UnitInstallmentsService();

